export default __webpack_public_path__ + "static/media/login.366a93d6.svg";